module.exports = __webpack_public_path__ + "static/media/guide.0545edc5.svg";